import { useEffect } from 'react';
import { useInventoryAdjustmentQuery } from '../../../../hooks/inventory/useInventoryAdjustmentQuery';
import { InventoryAdjustmentTableDTO } from '../../../../types/inventory/adjustment/InventoryAdjustmentTypes';
import FormModal from '../../../Modals/FormModal';
import MobileTable from '../../../Tables/mobile/MobileTable';
import DesktopTable from '../../../Tables/desktop/DesktopTable';

interface InventoryAdjustmentPendingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InventoryAdjustmentPendingModal: React.FC<
  InventoryAdjustmentPendingModalProps
> = ({ isOpen, onClose }) => {
  const {
    pendingList,
    handlerGetPendingAdjustments,
    // luego: handlerGetPendingAdjustmentForm
    handlerGetPendingAdjustmentForm,
  } = useInventoryAdjustmentQuery();

  // cargar pendientes al abrir
  useEffect(() => {
    if (isOpen) {
      handlerGetPendingAdjustments();
    }
  }, [isOpen]);

  // columnas (mínimas, claras)
  const columns = [
    { accessor: 'branchName', label: 'Sucursal' },
    { accessor: 'reason', label: 'Motivo' },
    { accessor: 'status', label: 'Estado' },
    {
      accessor: 'createdAt',
      label: 'Fecha / Hora',
      render: (row: any) => (
        <div className="flex flex-col">
          <span className="text-gray-900 text-sm">{row.createdDate}</span>
          <span className="text-gray-500 text-xs">{row.createdTime}</span>
        </div>
      ),
    },
  ];

  // acciones
  const actions = [
    {
      label: 'Continuar',
      icon: 'continue',
      onClick: (row: InventoryAdjustmentTableDTO) => {
        console.log('Continuar ajuste:', row.id);
        handlerGetPendingAdjustmentForm(row.id);
        // 🔜 aquí luego:
        // handlerGetPendingAdjustmentForm(row.id)
      },
    },
  ];

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Ajustes de Inventario Pendientes"
      maxWidth="max-w-6xl"
    >
      <div className="max-h-[70vh] overflow-y-auto px-6 py-4">
        {/* Mobile */}
        <div className="block lg:hidden">
          <MobileTable
            title="Ajustes Pendientes"
            description="Continúa un ajuste de inventario en proceso."
            data={pendingList}
            columns={columns}
            actions={actions}
            noDataMessage="No hay ajustes pendientes."
          />
        </div>

        {/* Desktop */}
        <div className="hidden lg:block">
          <DesktopTable
            data={pendingList}
            columns={columns}
            actions={actions}
            noDataMessage="No hay ajustes pendientes."
          />
        </div>
      </div>
    </FormModal>
  );
};

export default InventoryAdjustmentPendingModal;
